'use client';

import { useTranslations } from 'next-intl';
import { H1, P } from './styleConstants';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import CustomLink from 'components/shared/CustomLink';
import { SplineViewer } from 'components/shared/SplineViewer/SplineViewer';
import {
  bloodVisionDesktopSrc,
  bloodVisionMobileSrc,
} from 'components/shared/SplineViewer/scenes';
import styles from './HeroSection.module.css';

export const BloodVision_HeroSection = ({
  className,
}: {
  className?: string;
}) => {
  const { region: country } = useRegionLocale();
  const t = useTranslations('bloodVision');
  const tCommon = useTranslations('common');

  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
    >
      <div className={styles.canvasContainer}>
        <SplineViewer
          desktopSrc={bloodVisionDesktopSrc}
          mobileSrc={bloodVisionMobileSrc}
        />
      </div>
      {/* <Container className="bv-hero-content">
          <div className="main-content">
            <H1>
              Introducing
              <br />
              Blood Vision
            </H1>
            <P>
              Discover the world of Blood Vision, a new and exciting NFT
              collection.
            </P>
          </div>
          <div className="secondary-content">

          </div>
        </Container> */}

      <div className={styles.mainContent}>
        <H1>{t.rich('hero.title', { br: () => <br /> })}</H1>
        <P>
          {t.rich('hero.subtitle', {
            tm: (chunks) => <span style={{ opacity: '0.5' }}>{chunks}</span>,
          })}
        </P>
        <div className={styles.ctaContainer}>
          <CustomLink href="/blood-vision/buy">
            {tCommon('header.bookTest')}
          </CustomLink>
        </div>
        {country !== 'IN' && country !== 'US' ? (
          <p className={styles.comingDisclaimer}>{t('hero.comingSoon')}</p>
        ) : null}
      </div>
    </section>
  );
};
